import React from 'react'
import { NinetailedPreviewPluginData } from '@lib/api/ninetailed'
import { NinetailedPersonalizationPreviewProvider } from './preview-provider'
import { NinetailedDefaultProvider } from './provider'

export interface NinetailedProviderProps {
  children: React.ReactNode
  ninetailedPreviewPluginData?: NinetailedPreviewPluginData
}

export const NinetailedProvider: React.FC<NinetailedProviderProps> = ({ children, ninetailedPreviewPluginData }) => {
  if (ninetailedPreviewPluginData) {
    return (
      <NinetailedPersonalizationPreviewProvider ninetailedPreviewPluginData={ninetailedPreviewPluginData}>
        {children}
      </NinetailedPersonalizationPreviewProvider>
    )
  }

  return <NinetailedDefaultProvider>{children}</NinetailedDefaultProvider>
}
